// extracted by mini-css-extract-plugin
export default {"appearance-wrapper":"appearance_appearance-wrapper__IVOld","checkbox-item":"appearance_checkbox-item__eISs5","checkbox":"appearance_checkbox__2OLSF"};